export default "__VITE_PUBLIC_ASSET__e320c98e__"